import * as React from 'react';
import { TextField, Button } from '@material-ui/core';

interface Props {
  title: string;
  csvName?: string;
  ignoreList?: Array<string>;
  emailList?: Array<string>;
  hide: boolean;
  hideButton?: boolean;
};

export const BulkShowResultsListButton: React.FC<Props> = (prop: Props) => {
  let stripeLink: string = process.env.NODE_ENV === 'production' ?
    'https://dashboard.stripe.com/subscriptions/' : 'https://dashboard.stripe.com/test/subscriptions/';

  let csvName = prop.csvName || "bulkresponse";
  //converts current bulk utility arrays into a csv file.  Future ones that do not use email List or ignore list will need adjustments here
  const toCsv = (emailList: Array<string> | undefined, ignoreList: Array<string> | undefined) => {
    let headerString = '';
    let highestLength: number | undefined;
    let bodyString = '';
    if (emailList) {
      headerString += "Emails Affected,";
      highestLength = emailList.length;
    }
    if (ignoreList) {
      headerString += "Ignored Emails,"
      if (!highestLength || ignoreList.length > highestLength) {
        highestLength = ignoreList.length;
      }
    }
    if (highestLength && emailList && ignoreList) {
      for (var i = 0; i < highestLength; i++) {
        let stringCombine = ((emailList[i] || "'',") + (ignoreList[i] ? (", " + ignoreList[i] + "\n") : ("''\n")));
        bodyString += stringCombine;
      }
    }

    let finalString = `${headerString}\n${bodyString}`;
    const blob = new Blob([finalString], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = csvName;
    link.click();
  }

  if (prop.hide) {
    return (<></>)
  } else {
    return (
      <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h3>{prop.title}</h3>
          {!prop.hideButton && <Button
            style={{ height: "2.85em" }}
            variant="outlined"
            color="primary"
            onClick={() => toCsv(prop.emailList, prop.ignoreList)}>Export</Button>
          }
        </div>
        <div>
          {prop.emailList && prop.emailList.length > 0 &&
            <TextField
              multiline
              fullWidth
              value={prop.emailList.map(item => item).join(', \n')} />
          }
          {prop.ignoreList && prop.ignoreList.length > 0 &&
          <>
            <div>There was an error while processing the following Stripe ID's</div>
            {prop.ignoreList.map(id =>
              <div>
                <a target="_blank" rel="noreferrer" href={`${stripeLink + id}`}>{id}</a>
                <br></br>
              </div>
            )}
          </>}

        </div>
      </div>
    )
  }
}